
var searchBox = {
  open: function(){
    $('header .search-box').addClass('on');
    $('header .tools li > a').css('opacity', 0);
  },
  close: function(){
    $('header .search-box').removeClass('on');
    $('header .tools li > a').css('opacity', 1);
    setTimeout(function(){
      $('header .search-box input').val('');
    }, 200)
  }
}

$('header .search-box input').keyup(function (e) {
  if (e.which == 27) {
    searchBox.close()
  }
});

$(document).ready(function(){

  setTimeout(function(){
    $('header').css({
    'transform': 'translateY(0)',
    'opacity': 1
    });
    $('.fullshow .full-content').css('opacity', 1);
  }, 500);
  var showHeaderThumbnail = function(e){
    var dataThumb = e.attr('data-thumb');
    var target = e.parents('.inner-menu').find('li.image-preview img');
    target.attr('src', dataThumb);
  }

  $('body').on('mouseover', '.inner-menu li a[data-thumb]', function(){
    showHeaderThumbnail($(this));
  });

  $('body').on('mouseleave', '.inner-menu li a[data-thumb]', function(){
    $(this).parents('.inner-menu').find('li.image-preview img').attr('src', '');
  });



  var smallMenu = function(e){
    var item = e;
    // var itemTop = item.offset().top;
    var itemTop = item.get(0).getBoundingClientRect().top;

    const headerHeight = $('header').height();
    var childTarget = item.find('.inner-menu');
    var calc = (itemTop - headerHeight) * -1;
    // console.log(itemTop, headerHeight, calc, item.get(0).getBoundingClientRect());
    if(!item.hasClass('on')){
      $('header .main-menu .menu>li').addClass('hidden');
      $('header .main-menu .menu>li').removeAttr('style');
      item.removeClass('hidden');
      item.addClass('on');
      setTimeout(function(){
        item.css('transform', "translateY("+calc+"px)");
        childTarget.addClass('active');
      }, 200);
    } else {
      childTarget.removeClass('active');
      item.css('transform', 'translateY(0)');
      setTimeout(function(){
        $('header .main-menu .menu>li').removeClass('hidden on');
        $('header .main-menu .menu>li').removeAttr('style');
      }, 200);
    }

  }

  $('body').on('click', 'header .main-menu .menu>li', function(e){
    if(e.target !== this){
      return
    } else {
      if($(document).width() <= 992){
        smallMenu($(this))
      }
    }
  });

  $('body').on('click', 'header a#toggle-smallmenu', function(){

    $('header .main-menu .menu').toggleClass('on');
    $('body').toggleClass('nonscroll')
  });
});
